import { createSelector } from 'reselect'

const selectFoot = state => state.footer

const selectFooter = createSelector(
  selectFoot,
  footer => footer.footer
)
const selectIsFetching = createSelector(
  selectFoot,
  footer => footer.isFetching
)
const selectError = createSelector(
  selectFoot,
  footer => footer.error
)

export { selectFooter, selectIsFetching, selectError }



// WEBPACK FOOTER //
// ./src/containers/Footer/selectors.js